import React from "react";
import RpImageTextInline from "@/components/RpImageTextInline";

type LocationReport = {
  city?: string;
  location_name?: string;
  participant: {
    system_generated_participant_id?: string | number;
    user: {
      email?: string;
      first_name?: string;
      last_name?: string;
    };
  };
  state?: string;
  street_address?: string;
  system_generated_location_id?: string | number;
  zip_code?: string | number;
};

const LocationDetails = ({ report }: { report: LocationReport }) => {
  return (
    <div className="location-detail mb-3">
      <div className="card">
        <div className="card-body">
          <div className="row">
            <div className="col-lg-4 col-sm-6 mb-3">
              <RpImageTextInline
                svgIcon="location_mark"
                imageProps={{
                  color: "primary",
                }}
                text={
                  <>
                    <div className="title">Location Name</div>
                    <div className="value us-all text-break">
                      {report.location_name}
                    </div>
                  </>
                }
                alignCenter={false}
              />
            </div>
            <div className="col-lg-4 col-sm-6 mb-3">
              <RpImageTextInline
                svgIcon="map"
                imageProps={{
                  color: "primary",
                }}
                text={
                  <>
                    <div className="title">Location ID</div>
                    <div className="value us-all">
                      {report?.system_generated_location_id}
                    </div>
                  </>
                }
                alignCenter={false}
              />
            </div>
            <div className="col-lg-4 col-sm-6 mb-3">
              <RpImageTextInline
                svgIcon="email"
                imageProps={{
                  color: "primary",
                }}
                text={
                  <>
                    <div className="title">Email</div>
                    <div className="value us-all">
                      {report?.participant.user.email}
                    </div>
                  </>
                }
                alignCenter={false}
              />
            </div>
            <div className="col-lg-4 col-sm-6 mb-3">
              <RpImageTextInline
                svgIcon="person"
                imageProps={{
                  color: "primary",
                }}
                text={
                  <>
                    <div className="title">Participant Name</div>
                    <div className="value text-break">
                      {`${report.participant.user.first_name} ${report.participant.user.last_name}`}
                    </div>
                  </>
                }
                alignCenter={false}
              />
            </div>
            <div className="col-lg-4 col-sm-6 mb-3">
              <RpImageTextInline
                svgIcon="person"
                imageProps={{
                  color: "primary",
                }}
                text={
                  <>
                    <div className="title">Participant ID</div>
                    <div className="value us-all">
                      {report.participant.system_generated_participant_id}
                    </div>
                  </>
                }
                alignCenter={false}
              />
            </div>
            <div className="col-lg-4 col-sm-6 mb-3">
              <RpImageTextInline
                svgIcon="home"
                imageProps={{
                  color: "primary",
                }}
                text={
                  <>
                    <div className="title">Address</div>
                    <div className="value">
                      {`${report.street_address} ${report.city}, ${report.state} ${report.zip_code}`}
                    </div>
                  </>
                }
                alignCenter={false}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationDetails;
